// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.safemoon",
    name: "SafeMoon",
    homepage: "https://safemoon.com/",
    image_id: "ea0140c7-787c-43a4-838f-d5ab6a342000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/safemoon/id1579735495",
        android: "https://play.google.com/store/apps/details?id=net.safemoon.androidwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "safemoon://",
        universal: "https://safemoon.com/wc/wc",
    },
    desktop: {
        native: "safemoon://",
        universal: "https://safemoon.com/wc/wc",
    },
};
//# sourceMappingURL=index.js.map